import {Pipe, PipeTransform} from '@angular/core';
import {ChargeRecordDto} from '../domain/chargeRecord/chargeRecordDto';

@Pipe({
    name: 'chargeRecordMediaDisplayName'
})
export class ChargeRecordMediaDisplayNamePipe implements PipeTransform {

    constructor() {
    }

    transform(chargeRecord: ChargeRecordDto): string {
        return chargeRecord?.startingMediumAlias ?
            chargeRecord?.startingMediumAlias :
            chargeRecord?.startingMediumPublicCode;
    }
}
